import { ScrollWithShadows } from "components/layout/utils/ScrollWithShadows";
import { Stack, Typography } from "@mui/material";
import { T } from "components/util/t";
import { Section } from "./HomePage";
import { Fake } from "../../layout/skeleton/Fake";
import { EventCard } from "components/routes/root/eventCard/EventCard";
import { EventCardDetailsSection } from "components/routes/root/eventCard/EventCardDetailsSection";
import { EventCardMainSection } from "components/routes/root/eventCard/EventCardMainSection";

export const FeaturedEventsSkeleton = () => {
    return (
        <Section className="skeleton" marginTop={6}>
            <Typography variant="h3" component="h3" sx={(theme) => ({ marginBottom: theme.spacing(2), paddingX: theme.spacing(2) })}>
                <T>Explore live and upcoming events</T>
            </Typography>
            <ScrollWithShadows shadowsColor="background.default">
                <Stack paddingX={2} spacing={2} direction="row">
                    <FakeEventPair />
                    <FakeEventPair />
                    <FakeEventPair />
                    <FakeEventPair />
                </Stack>
            </ScrollWithShadows>
        </Section>
    );
};

const FakeEventPair = () =>
    <Stack direction="column" spacing={2}>
        <FakeEventCard/>
        <FakeEventCard/>
    </Stack>;

const FakeEventCard = () => {
    return (
        <EventCard>
            <EventCardMainSection mb={0.125}>
                <Stack direction="row" spacing={2} justifyContent="space-between">
                    <Typography variant="label2"><Fake size={28} /></Typography>
                    <Typography variant="body"><Fake size={16} /></Typography>
                </Stack>
                <Typography variant="h7"><Fake size={42} /></Typography>
                <Typography variant="body2"><Fake size={20} /></Typography>
            </EventCardMainSection>
            <EventCardDetailsSection>
                <Typography variant="h4" py={0.125}><Fake size={7} /></Typography>
            </EventCardDetailsSection>
        </EventCard>
    );
};
